import React, { Fragment } from 'react';
import Grid from '@material-ui/core/Grid';
//import { Link } from 'react-router-dom';
//import Button from 'src/ui/library/Button';
//import ArrowBack from '@material-ui/icons/ArrowBack';
import intl from 'react-intl-universal';
//import { DOCUMENTS_URL } from 'src/constants/constants.js';
import DocumentInfoContainer from 'src/ui/features/Documents/containers/DocumentInfoContainer';
import HistoryDisplayContainer from 'src/ui/library/HistoryDisplay';
import DocumentsDetailTabPres from '../presentational/DocumentsDetailTabPres';
import DocumentCasesContainer from '../containers/DocumentCasesContainer';
import { fnShowNewDashboard } from 'src/helpers/commonFunctions';

export const DocumentsDetailPres = props => {
  const {
    tab,
    documentDetailName,
    documentDetailType,
    isTaskFlow,
    documentDetailSubtype,
    documentDetailEmployeeName,
    documentDetailEmployeeGUID,
    isCorpClient,
  } = props;

  return (
    <Fragment>
      {!isTaskFlow && (
        <div className={fnShowNewDashboard() ? 'new-document-header document-details-header' : 'document-details-header'}>
          <Grid container className="header-grid" spacing={0}>
            <Grid item xs={1} className="case-header-back-button">
              <HistoryDisplayContainer history={props.history} type={'white'} />
            </Grid>
            <Grid item xs={2}>
              <div className="header-field">
                <label className="field-label">{intl.get('documents.documentDetails.subheader.documentType')}</label>
                <span className="field-text">{documentDetailType}</span>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div className="header-field">
                <label className="field-label">{intl.get('documents.documentDetails.subheader.documentSubtype')}</label>
                <span className="field-text">{documentDetailSubtype ? documentDetailSubtype : '-'}</span>
              </div>
            </Grid>
            <Grid item xs={2}>
              <div className="header-field">
                <label className="field-label">{intl.get('documents.documentDetails.subheader.documentName')}</label>
                <span className="field-text">{documentDetailName}</span>
              </div>
            </Grid>
            <Grid item xs={5}>
              <div className="header-field">
                <label className="field-label">{intl.get('documents.documentDetails.subheader.employeeName')}</label>
                <span className="field-text">{documentDetailEmployeeName}</span>
              </div>
            </Grid>
          </Grid>
        </div>
      )}
      <Grid container className="document-detail-content" spacing={0}>
        <Grid item xs={12} className="document-detail-tabs">
          <DocumentsDetailTabPres tab={tab} onChange={props.handleTabSelect} isTaskFlow={isTaskFlow} isCorpClient={isCorpClient} />
        </Grid>
        <Grid item xs={12} className={fnShowNewDashboard() ? 'new-document-body document-detail-body' : 'document-detail-body'}>
          {tab === 0 && <DocumentInfoContainer match={props.match} history={props.history} empGUID={documentDetailEmployeeGUID} />}
          {!isTaskFlow && tab === 1 && <DocumentCasesContainer {...props} />}
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default DocumentsDetailPres;
